import { useLiveNotice } from './LiveFeedback';
import { hasProductExposure } from "../../../../Component/tool/productExposure";
import SellerStartNotification from "./SellerStartNotification";
import { parseLiveClosingTime } from '../../../User/Live/LiveClosingCountdown';
import ExpandableNotice from "../../../../Component/UI/ExpandableNotice";
import SellerNotice from "../../../../Component/UI/SellerNotice";
import LiveStatusBadge from "../../../../Component/UI/LiveStatusBadge";
import LiveSalesTotal from "./LiveSalesTotal";
import LivePreviewState from "./LivePreviewState";
import BroadcastProductCard from "../../LiveManage/BroadcastProductCard";
import api from "../../../../Component/axios_Interceptor/api";
/* eslint-disable react/jsx-pascal-case */
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import io, { Socket } from "socket.io-client";
import styled, { StyleSheetManager } from "styled-components";
import { createPortal } from "react-dom";
import Layout_user from "../../../../Component/UI/Layout_user";
import url, { SOCKET_SERVER_URL } from "../../../../Component/server";
import { Icon, RowView, CenterView } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import ChatComponent from "../../../Chat/ChatComponent";
import LiveChatContent from "./LiveChatContent";
import { handleChatComposerKeyDown } from "../../../../Component/Support/chatComposerKeyboard";
import { qaUpdated } from "../../../Chat/liveQa";
import { sellerNoticeUpdated } from "../../../Broadcast/sellerNotice";
import Live_Component, { LivePlayerHandle } from "./Live_Component";
import { useTimedExposure } from "../../../User/Live/useTimedExposure";
import { useSaleProductInfo } from "../../../User/Live/useSaleProductInfo";
import { mediaUrl } from "../../../../Component/tool/mediaUrl";
import PurchaseNotice, { usePurchaseNotices } from "../../../User/Live/PurchaseNotice";
import LivePreviewNotices from "./LivePreviewNotices";
import { live_info_type } from "../../../User/Live/Live";
// import { useToken } from "../../../../Component/Context/useToken";

interface BuyBtnProps {
  $count: number;
}

interface VolumeProps {
  value: number;
}

interface ChatComponentRef {
  sendMessage: () => Promise<boolean>;
}

type live_notice_type = {
  seq: number;
  live_seq: number;
  type: string;
  title: string | null;
  content: string;
  crt_dt: string;
};

type props_data_type = {
  seq: number;
  live_seq: number;
  name: string;
  price: number;
  option_check: string;
  init_cnt: number;
  current_cnt: number;
  product_status: string;
  exposure_price_mode?: 'visible' | 'seller' | 'hidden';
  product_num: number | null;
  unique_option1: string[];
  unique_option2: string[];
  thumbnail_img?: string | null;
};

const Manage_Live = (props: { seq: string | undefined; totalSales?: number | null; sellerNotice?: string; canSendStartNotification?: boolean; canManageProducts?: boolean; chatTarget?: HTMLElement | null; onLiveStatusChange?: (status: string | null, canRestart?: boolean) => void }) => {
  const notifyLive = useLiveNotice();
  const [data, set_Data] = useState<props_data_type | null>();
  const [stockCounts, setStockCounts] = useState<Record<number, number>>({});
  const changePriceVisibility = async () => {
    if (!data) return;
    const productSeq = data.seq;
    const mode = data.exposure_price_mode === undefined || data.exposure_price_mode === 'visible' ? 'seller' : 'visible';
    const response = await api.patch(url.Communication_url.product_update, {
      live_seq: Number(props.seq), product_list: [{ seq: productSeq, exposure_price_mode: mode }],
    }, { headers: { 'Content-Type': 'application/json' } });
    if (response.data?.total !== 1 || response.data?.success !== 1 || response.data?.fail !== 0) throw new Error('Price disclosure failed');
    set_Data(current => current?.seq === productSeq ? { ...current, exposure_price_mode: mode } : current);
  };

  const [productInfoSyncVersion, setProductInfoSyncVersion] = useState(0);
  const { images: productImages } = useSaleProductInfo(data?.seq, true, productInfoSyncVersion);
  const [live_info, set_Live_Info] = useState<live_info_type>();
  const previewLiveSeq = live_info?.seq;
  const previewLiveStatus = live_info?.live_status;
  const videoOwnsExposure = useRef(false);
  const exposure = useTimedExposure<props_data_type>(
    live_info && ['방송중', '리허설'].includes(live_info.live_status) ? live_info.seq : undefined,
    item => { videoOwnsExposure.current = true; set_Data(item); },
  );
  useEffect(() => { videoOwnsExposure.current = false; set_Data(null); }, [props.seq, live_info?.live_status]);
  useEffect(() => {
    if (!props.chatTarget || previewLiveSeq !== Number(props.seq) || !previewLiveStatus
      || !['방송중', '리허설'].includes(previewLiveStatus) || videoOwnsExposure.current) return;
    // The detail preview also restores its current product before video playback is available.
    // Once playback starts, video cues remain authoritative for subsequent changes.
    let active = true;
    axios.get(url.Communication_url.is_visable_product, {
      params: { live_seq: previewLiveSeq }, timeout: 10000,
    }).then(({ data: product }) => {
      if (active && !videoOwnsExposure.current) set_Data(
        product?.live_seq === previewLiveSeq && hasProductExposure(product) ? product : null,
      );
    }).catch(error => {
      if (active && !videoOwnsExposure.current && error.response?.status === 404) set_Data(null);
    });
    return () => { active = false; };
  }, [props.seq, props.chatTarget, previewLiveSeq, previewLiveStatus, productInfoSyncVersion]);
  const [live_notice, set_Live_Notice] = useState<live_notice_type>();
  const [live_time, set_Live_Time] = useState<string>("00:00:00");
  useEffect(() => {
    const startedAt = parseLiveClosingTime(live_info?.start_dt);
    if (!['방송중', '리허설'].includes(live_info?.live_status || '') || startedAt === null) {
      set_Live_Time('00:00:00');
      return;
    }
    const update = () => {
      const seconds = Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
      set_Live_Time([Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
        .map(value => String(value).padStart(2, '0')).join(':'));
    };
    update();
    const timer = window.setInterval(update, 1000);
    return () => window.clearInterval(timer);
  }, [live_info?.seq, live_info?.start_dt, live_info?.live_status]);
  const [viewer_count, set_Viewer_Count] = useState<number>(0);
  const [mesage, set_Mesage] = useState<string>("");
  const { notices: purchaseNotices, showPurchaseNotice } = usePurchaseNotices();

  const Navigate = useNavigate();

  const { state } = useLocation();

  const get_live_info = () => {
    axios
      .get(url.Communication_url.get_live_info, {
        params: {
          seq: props.seq,
        },
      })
      .then(function (response) {
        set_Live_Info(response.data);
      })
      .catch(function (error) {
        // console.log("get-live-info error", error);
      });
  };

  useEffect(() => {
    if (props.seq !== "undefined") get_live_info();
    const statusTimer = props.seq !== "undefined"
      ? window.setInterval(get_live_info, 5000)
      : undefined;

    return () => {
      if (statusTimer) window.clearInterval(statusTimer);
    };
  }, [props.seq]);

  const chatRef = useRef<ChatComponentRef>(null); // Ref 타입을 명시

  const handleSendMessage = async () => {
    if (!chatRef.current) return;
    if (mesage.length > 100) { notifyLive("입력 가능한 글자 수는 최대 100자입니다."); return; }
    const content = mesage;
    if (await chatRef.current.sendMessage()) set_Mesage(current => current === content ? "" : current);
  };

  // 볼륨조절
  const [volume, setVolume] = useState<number>(50); // 초기 볼륨 값
  const [isMuted, setIsMuted] = useState(false);
  const [playbackMuted, setPlaybackMuted] = useState(true);
  const livePlayerRef = useRef<LivePlayerHandle>(null);
  const [volume_on, set_Volume_On] = useState<boolean>(false);
  const Volume_OnOff = () => set_Volume_On(!volume_on);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVolume(Number(event.target.value));
  };
  // const { logout } = useToken();

  // 소켓
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (props.seq === "undefined") {
      notifyLive("방송정보가 없습니다.");
      Navigate("/", { replace: true });
    }
    if (live_info) {

      // 소켓 연결을 초기화합니다.
      const newSocket = io(SOCKET_SERVER_URL, {
        path: "/socket.io", // nginx에서 location /live/로 프록시 중이므로 필요
        transports: ["websocket"], // polling을 비활성화하고 WebSocket만 사용
      });
      setSocket(newSocket);
      newSocket.on("connect", () => {
        newSocket.emit("join-channel", { channelId: live_info?.channel_name });
        setProductInfoSyncVersion(version => version + 1);
      });

      let productRefreshTimer: ReturnType<typeof setTimeout> | undefined;
      newSocket.on("Live Q&A Updated", (update: { liveSeq: number }) => qaUpdated(update.liveSeq));
      newSocket.on("Seller Notice Updated", (update: { liveSeq: number }) => sellerNoticeUpdated(update.liveSeq));
      newSocket.on("Product List Changed", (update: { liveSeq: number }) => {
        if (update?.liveSeq !== Number(props.seq)) return;
        clearTimeout(productRefreshTimer);
        productRefreshTimer = setTimeout(() => setProductInfoSyncVersion(version => version + 1), 250);
      });

      newSocket.on("Inventory Changed", (inventory: { productSeq: number; currentCnt: number }) => {
        if (!Number.isSafeInteger(inventory?.productSeq) || !Number.isFinite(inventory.currentCnt)) return;
        setStockCounts(counts => ({ ...counts, [inventory.productSeq]: inventory.currentCnt }));
      });

      newSocket.on("Viewer Count", (data: string) => {
        // console.log("Viewer Count : ", data);
        set_Viewer_Count(Number(data));
      });
      newSocket.on("Live Notice", (data: live_notice_type[]) => {
        set_Live_Notice(data[0]);
      });

      props.seq !== "undefined" && get_live_notice();

      // 컴포넌트가 언마운트될 때 소켓 연결을 정리합니다.
      return () => {
        clearTimeout(productRefreshTimer);
        newSocket.disconnect();
      };
    }
  }, [live_info?.channel_name, live_info?.live_status, props.seq]);

  // const { userinfoReturn } = useToken();

  const get_live_notice = () => {
    axios
      .get(url.Communication_url.get_live_notice, {
        params: {
          seq: props.seq,
          type: "ln",
        },
      })
      .then(function (response) {
        set_Live_Notice(response.data[0]);
      })
      .catch(function (error) {
        // console.log("get-live-info error", error);
      });
  };

  const isStreaming = live_info?.live_status === "방송중" || live_info?.live_status === "리허설";
  const [now, setNow] = useState(Date.now);
  const closingAt = parseLiveClosingTime(live_info?.live_finish);
  const openingAt = parseLiveClosingTime(live_info?.live_start);
  const canRestart = live_info?.seq === Number(props.seq) && live_info.live_status === '종료' && (Boolean(live_info.integration_test)
    || (openingAt !== null && closingAt !== null && now >= openingAt - 5 * 60 * 1000 && now < closingAt));
  useEffect(() => {
    props.onLiveStatusChange?.(live_info?.live_status ?? null, canRestart);
  }, [live_info?.live_status, canRestart, props.onLiveStatusChange]);
  const remaining = (closingAt ?? 0) - now;
  const showEndWarning = live_info?.live_status === '방송중' && remaining > 0 && remaining <= 5 * 60 * 1000;
  useEffect(() => {
    if (!['방송중', '종료'].includes(live_info?.live_status || '')) return;
    const updateNow = () => setNow(Date.now());
    updateNow();
    const timer = window.setInterval(updateNow, 1000);
    window.addEventListener('focus', updateNow);
    document.addEventListener('visibilitychange', updateNow);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', updateNow);
      document.removeEventListener('visibilitychange', updateNow);
    };
  }, [live_info?.live_status, live_info?.live_finish]);

  return (
    <>
    <Box $streaming={isStreaming}>
      {isStreaming ? (
        <>
        <Streaming_Box role="region" aria-label="라이브 영상">
            <>
              <Live_Component
                ref={livePlayerRef}
                onMutedChange={muted => {
                  setPlaybackMuted(muted);
                  if (!muted) setIsMuted(false);
                }}
                volume={isMuted ? 0 : volume}
                manage={true}
                live_info={live_info}
                onPlaybackStarted={latency => { videoOwnsExposure.current = true; exposure.onPlaybackStarted(latency); }}

                onPlaybackPaused={exposure.onPlaybackPaused}
                onProductMetadata={exposure.onMetadata}
              />

              {purchaseNotices.length > 0 && <PurchaseNotice $admin role="log" aria-label="구매 완료 알림" aria-live="polite" aria-relevant="additions">
                {purchaseNotices.map(notice => <div key={notice.id}>{notice.content}</div>)}
              </PurchaseNotice>}



              {showEndWarning && <EndWarning role="alert" aria-atomic="true">
                라이브 종료까지 5분 이내로 남았습니다. {new Intl.DateTimeFormat('ko-KR', {
                  timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
                }).format(closingAt!)}에 자동 종료됩니다. 방송을 마무리해주세요.
              </EndWarning>}
              {live_notice && live_notice.content !== " " && (
                <Notice_Box>
                  <Notice role="note" aria-label="라이브 공지"><ExpandableNotice content={live_notice.content} html previewLength={15} consumeOutsideClick deferResize /></Notice>
                </Notice_Box>
              )}
              <Bottom_Box $standaloneChat={!!props.chatTarget}>
                <Bottom_Row>
                  <Item_Chat_Box>
                    {!props.chatTarget && <>
                    <Chat_Box>
                      <ChatComponent
                        ref={chatRef}
                        mesage={mesage}
                        all_visible={true}
                        live_info={live_info!}
                        onPurchaseNotification={showPurchaseNotice}
                      />
                    </Chat_Box>
                    </>}
                    {data && hasProductExposure(data) && (
                      <BroadcastProductCard product={data} liveSeq={Number(props.seq)} rehearsal={live_info?.live_status === "리허설"} copyableTitle
                        onChangePriceVisibility={props.canManageProducts ? changePriceVisibility : undefined}
                    imageUrl={productImages[0] || mediaUrl(data.thumbnail_img)}
                    count={stockCounts[data.seq] ?? data.current_cnt} />
                    )}
                  </Item_Chat_Box>
                </Bottom_Row>
                {!props.chatTarget && <Chat_Insert_Box>
                  <Chat_Insert>
                    <Insert_Text
                      value={mesage}
                      placeholder="메시지를 입력해주세요."
                      onChange={(e) => set_Mesage(e.target.value)}
                      rows={Math.min(3, mesage.split('\n').length)} maxLength={100} enterKeyHint="send"
                      onKeyDown={event => handleChatComposerKeyDown(event, set_Mesage, () => { void handleSendMessage(); })}
                    />

                    <Send_Icon
                      src={require("../../../../Image/ic_send_white.png")}
                      onClick={handleSendMessage}
                    />
                  </Chat_Insert>
                </Chat_Insert_Box>}
              </Bottom_Box>
            </>
        </Streaming_Box>
        <LivePreviewNotices liveSeq={Number(props.seq)} />
              <Status_Box aria-label="라이브 진행 현황">
                <LiveStatusBadge status={live_info?.live_status} />
                <Time_Box>
                  <Shadow_Icon
                    src={require("../../../../Image/ic_time_white.png")}
                  />
                  &nbsp;{live_time}
                </Time_Box>
                <Viewer_Count_Box>
                  <Shadow_Icon
                    src={require("../../../../Image/ic_viewer_white.png")}
                  />
                  &nbsp;{viewer_count}명
                </Viewer_Count_Box>
                <Mute_Button
                  type="button"
                  aria-label={isMuted || playbackMuted ? "소리 켜기" : "소리 끄기"}
                  aria-pressed={isMuted || playbackMuted}
                  onClick={() => {
                    if (isMuted || playbackMuted) {
                      setIsMuted(false);
                      if (process.env.NODE_ENV !== "production" && document.querySelector('meta[name="fanbird-local-review"]')) setPlaybackMuted(false);
                      livePlayerRef.current?.unmute(volume);
                    } else setIsMuted(true);
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M11 5 6 9H3v6h3l5 4V5Z" />
                    {isMuted || playbackMuted ? <path d="m16 9 5 6m0-6-5 6" /> : <><path d="M15.5 8.5a5 5 0 0 1 0 7" /><path d="M19 5a10 10 0 0 1 0 14" /></>}
                  </svg>
                </Mute_Button>
              </Status_Box>
        </>
      ) : (
        <LivePreviewState
          status={live_info?.live_status}
          title={live_info?.live_title}
          onBrowse={() => Navigate("/admin/livelist")}
        />
      )}
      {props.canSendStartNotification && live_info?.seq === Number(props.seq) && <SellerStartNotification
        key={props.seq} liveSeq={live_info.seq} status={live_info.live_status} />}
    </Box>
    {props.totalSales !== undefined && <LiveSalesTotal total={props.totalSales} />}
    {props.chatTarget && createPortal(<StyleSheetManager target={document.head}>
      <LiveChatContent liveInfo={live_info} liveSeq={Number(props.seq)} onPurchaseNotification={showPurchaseNotice} moderationFilters />
    </StyleSheetManager>, props.chatTarget)}
    </>
  );
};

export default Manage_Live;

const Box = styled.div<{ $streaming: boolean }>`
  background-color: ${props => props.$streaming ? "transparent" : "var(--admin-theme-raised, #f7f5fa)"};
  width: 100%;
  flex-direction: column;
  max-height: none;
  min-height: 0;
  display: flex;
  align-items: stretch;
`;

const Streaming_Box = styled.div.attrs<{ 'data-live-media-display'?: boolean }>({ 'data-live-media-display': true })`
  background: #000;
  border-radius: var(--radius-md);
  > [translate="no"]:has(> video) {
    z-index: 0;
    > [role="status"] { top: 50%; }
  }
  width: 100%;
  aspect-ratio: 9 / 16;
  flex-shrink: 0;
  /* background-color: #de9c9c; */
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;



const Status_Box = styled.div`
  z-index: 1; box-sizing: border-box; width: 100%; padding: var(--space-2) 0;
  display: flex; align-items: center; justify-content: space-between; gap: var(--space-2);
  user-select: none;
`;
const Mute_Button = styled.button.attrs<{ 'data-live-icon-control'?: boolean }>({ 'data-live-icon-control': true })`
  box-sizing: border-box; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
  width: var(--control-sm); height: var(--control-sm); padding: 0;
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
  background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; cursor: pointer;
  &:hover { background: var(--color-bg-subtle); border-color: var(--color-border-strong); }
  &:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { width: var(--control-lg); height: var(--control-lg); }
`;
const Time_Box = styled.div`
  display: flex; align-items: center; white-space: nowrap;
  font-family: var(--font-family-base); font-weight: 600; font-size: var(--text-body);
  color: var(--color-text-primary); font-variant-numeric: tabular-nums;
`;
const Viewer_Count_Box = styled(Time_Box)``;
const Shadow_Icon = styled(Icon)`width: var(--space-5); height: var(--space-5);`;

const Notice_Box = styled.div`
  display: flex;
  position: relative;
  z-index: 1;
`;

const Notice = styled.div`
  box-sizing: border-box;
  background-color: var(--admin-theme-surface, rgba(255, 255, 255, 0.9));
  border: 1px solid var(--admin-theme-border, transparent);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--admin-theme-text, #111);
  margin: 14px 16px 0;
  font-size: 14px;
  width: fit-content;
  min-width: 0;
  max-width: calc(100% - 32px);
`;

const Bottom_Box = styled.div<{ $standaloneChat: boolean }>`
  display: flex;
  width: 100%;
  /* background-color: #a9a9a9; */
  height: ${props => props.$standaloneChat ? "auto" : "350px"};
  flex-shrink: 0;
  margin-top: auto;
  flex-direction: column;
  position: relative;
  padding: 15px 0 0 0;
  box-sizing: border-box;
  z-index: 1;
`;

const Chat_Insert_Box = styled.div`
  align-self: flex-end;
  min-height: 50px;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: auto;
`;

const Chat_Insert = styled.div`
  width: 100%;
  min-height: 50px;
  background-color: rgba(20, 20, 20, 0.85);
  padding: 0px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  align-items: center;
  display: flex;
  position: relative;
  box-sizing: border-box;
  justify-content: space-between;
  color: white;
`;

const Bottom_Row = styled(RowView)`
  flex: 1;
  margin-bottom: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  width: 100%;
`;

const Item_Chat_Box = styled.div`
  display: flex;
  height: 100%;
  flex: 1;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  box-sizing: border-box;
`;

const Chat_Box = styled.div`
  width: 100%;
  max-width: 100%;
  height: 272px;
  max-height: 272px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  position: relative;
  box-sizing: border-box;
`;




const Volume_Box = styled.div`
  z-index: 10;
  background-color: var(--admin-theme-surface, white);
  position: absolute;
  display: flex;
  right: 15px;
  top: 25%;
  width: 35px;
  height: 250px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
`;

const Volume = styled.input.attrs({ type: "range" })<VolumeProps>`
  -webkit-appearance: none;
  display: flex;
  position: absolute;
  width: 220px;
  height: 8px;
  background: transparent;
  border-radius: 5px;
  outline: none;
  transform: rotate(270deg);
  writing-mode: bt-lr;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--admin-theme-raised, #e4e4e4);
    border: 6px solid var(--admin-theme-border, white);
    cursor: pointer;
    transform: translateY(-6px);
    box-shadow: 0 0px 5px rgba(0, 0, 0, 0.5);
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 8px;
    cursor: pointer;
    background: linear-gradient(
      to right,
      #ea2922 ${(props) => props.value}%,
      var(--admin-theme-raised, #e4e4e4) ${(props) => props.value}%
    );
    border-radius: 5px;
    position: relative;
  }
`;

const Send_Icon = styled(Shadow_Icon)`
  justify-self: flex-end;
  cursor: pointer;
  &:active {
    opacity: 0.5;
  }
`;

const Insert_Text = styled.textarea`
  resize: none;
  line-height: 1.5;
  outline: none;
  border: none;
  width: 100%;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 0);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
  color: white;
  &::placeholder {
    color: white;
  }
`;

const EndWarning = styled.div`
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  align-self: flex-start;
  flex-shrink: 0;
  width: fit-content;
  max-width: calc(100% - 32px);
  margin: 8px 16px 12px;
  padding: 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  font-size: 14px;
  line-height: 1.5;
`;
